const navMenuTitles = {
  Eden: '618 Data',
  Progress: 'Informes de Progreso',
  InformesGenerales: 'Informes Generales',
  Dashboard: 'Dashboard',
  AT: 'Asistencia Tecnológica',
};

export default navMenuTitles;
